import React from 'react';
import PropTypes from 'prop-types';
import Button from 'components/Button';
import Link from '../Models/Link/Link';

import css from './GroupWithLinksBlock.module.scss';

import { THEMES } from 'constants/themes';

const GroupWithLinksBlock = ({
    groupName,
    links,
    theme,
    headingTagLevel = 3
}) => {
    const HeadingTag = `h${headingTagLevel}`;
    return (
        <div className={css.block}>
            {groupName && <HeadingTag className={css.heading}>{groupName}</HeadingTag>}
            {links && (
                <ul className={css.list}>
                    {links.map((link, index) => (
                        <li key={index} className={css.listItem}>
                            <Button 
                                secondary 
                                href={link.url}
                                target={link.openInNewWindow ? '_blank' : null}
                                {...{light : theme === THEMES.darkgray}}
                                className={css.link}
                            >
                                {link.linkText}
                            </Button>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

GroupWithLinksBlock.propTypes = {
    groupName: PropTypes.string,
    links: PropTypes.arrayOf(PropTypes.shape(Link.propTypes)),
    theme: PropTypes.oneOf(Object.values(THEMES)),
    headingTagLevel: PropTypes.oneOf([2, 3]),
};

GroupWithLinksBlock.propTypesMeta = {
    theme: 'exclude',
    headingTagLevel: 'exclude'
};

export default GroupWithLinksBlock;


// WEBPACK FOOTER //
// ./src/components/GroupWithLinksBlock/GroupWithLinksBlock.jsx